import { EventTypes } from "redux-segment";

export const trackPageAction = (pageTitle) => ({
  type: "NOOP",
  meta: {
    analytics: {
      eventType: EventTypes.page,
      eventPayload: { name: pageTitle }
    }
  }
});

export const trackEventAction = (eventName) => ({
  type: "NOOP",
  meta: {
    analytics: {
      eventType: EventTypes.track,
      eventPayload: { event: eventName }
    }
  }
});

export const trackIdentityAction = (id) => ({
  type: "NOOP",
  meta: {
    analytics: {
      eventType: EventTypes.identify,
      eventPayload: { userId: id }
    }
  }
});



// WEBPACK FOOTER //
// ./src/js/actions/shared/tracking-actions.js